export * from '@primeuix/themes/material/confirmpopup';
export { default } from '@primeuix/themes/material/confirmpopup';
